<div{{#if wrapperClass}} class="{{wrapperClass}}"{{/if}}>
	<canvas id="{{id}}" width={{width}} height={{height}}>
	</canvas>
</div>
